import { render, staticRenderFns } from "./Comisionista.vue?vue&type=template&id=c4c6346e&"
import script from "./Comisionista.vue?vue&type=script&lang=js&"
export * from "./Comisionista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports